export default __webpack_public_path__ + "static/media/handy-qr-template.1d54f498.pdf";